import type { UserSearchFilter, UserSearchHitDto } from '@tracedocuments/types';

import { apiFetch } from './fetch';

export async function searchUsers(
  query: string,
  filter: UserSearchFilter = 'all',
  skip = 0,
  take = 20,
  taxId?: string,
): Promise<UserSearchHitDto[]> {
  const params = new URLSearchParams({
    q: query,
    filter,
    skip: String(skip),
    take: String(take),
  });
  if (taxId) params.set('taxId', taxId);
  const res = await apiFetch(`/api/users/search?${params}`);
  if (res.status === 429) throw new Error('rate_limit');
  if (!res.ok) throw new Error('user search failed');
  return res.json();
}

export async function checkHandleAvailability(handle: string): Promise<{ available: boolean }> {
  const params = new URLSearchParams({ handle });
  const res = await apiFetch(`/api/users/handle/availability?${params}`);
  if (!res.ok) throw new Error('availability check failed');
  return res.json();
}

export async function updatePublicHandle(handle: string): Promise<void> {
  const res = await apiFetch('/api/auth/public-handle', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ handle }),
  });
  if (!res.ok) throw new Error('update handle failed');
}

export async function updateDiscoverability(isDiscoverable: boolean): Promise<void> {
  const res = await apiFetch('/api/auth/discoverability', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ isDiscoverable }),
  });
  if (!res.ok) throw new Error('update discoverability failed');
}

export async function fetchConversationReadiness(): Promise<{
  ready: boolean;
  missingDefaultPreset: boolean;
  textMessagesEnabled: boolean;
  e2eeTextEnabled: boolean;
}> {
  const res = await apiFetch('/api/conversations/readiness');
  if (!res.ok) throw new Error('conversation readiness failed');
  return res.json();
}
